(function () {
  'use strict';

  /**
   * @typedef {import('./types').AssortmentResponse} AssortmentResponse
   * @typedef {import('./types').StockItem} StockItem
   * @typedef {import('./types').UnitType} UnitType
   * @typedef {import('./types').MetricType} MetricType
   * @typedef {import('./types').FreeApartmentsChartItem} FreeApartmentsChartItem
   */

  angular
    .module('dashboard.stock')
    .controller('dashboardStockCtrl', dashboardStockCtrl);

  dashboardStockCtrl.$inject = [
    'DashboardStock',
    '$translate',
    '$rootScope',
    '$scope',
    'datamatic',
    'moment',
  ];

  function dashboardStockCtrl(
    DashboardStock,
    $translate,
    $rootScope,
    $scope,
    datamatic,
    moment,
  ) {
    var vm = this;

    /** @type {MetricType} */
    vm.metricStock = 'count';
    /** @type {MetricType} */
    vm.metricStockAge = 'count';
    /** @type {MetricType} */
    vm.metricStockRooms = 'count';

    vm.stock = {};
    vm.stockAge = {};
    vm.stockRooms = {};

    vm.noData = true;
    /** @type {AssortmentResponse | {}} */
    vm.chartData = {};
    vm.lastUpdatedAt = moment().format();

    var requestInProgress = false;

    var textNotInStock = $translate.instant(
      'settings.page.customizations.unit.statuses.type.notinstock',
    );
    var textFree = $translate.instant(
      'settings.page.customizations.unit.statuses.type.free',
    );
    var textBooked = $translate.instant(
      'settings.page.customizations.unit.statuses.type.booked',
    );
    var textSold = $translate.instant(
      'settings.page.customizations.unit.statuses.type.sold',
    );
    var textMonths = $translate.instant('general.months');
    var textRooms = $translate.instant('lead.popup.links.room');
    var textValue = $translate.instant('reports.page.sales.by.time.value');
    var textCount = $translate.instant('reports.page.sales.by.time.count');
    var textSqm = $translate.instant('reports.page.sales.by.time.sqm');
    $rootScope.$on('$translateChangeSuccess', function () {
      textNotInStock = $translate.instant(
        'settings.page.customizations.unit.statuses.type.notinstock',
      );
      textFree = $translate.instant(
        'settings.page.customizations.unit.statuses.type.free',
      );
      textBooked = $translate.instant(
        'settings.page.customizations.unit.statuses.type.booked',
      );
      textSold = $translate.instant(
        'settings.page.customizations.unit.statuses.type.sold',
      );
      textMonths = $translate.instant('general.months');
      textRooms = $translate.instant('lead.popup.links.room');
      textValue = $translate.instant('reports.page.sales.by.time.value');
      textCount = $translate.instant('reports.page.sales.by.time.count');
      textSqm = $translate.instant('reports.page.sales.by.time.sqm');
    });
    var tabs = [
        {
          title: $translate.instant('unit.popup.apartment'),
          type: 'apartment',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.commercial.unit'),
          type: 'office',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.hotel.type'),
          type: 'hotel type',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.store.room'),
          type: 'storeroom',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.attic'),
          type: 'attic',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.parking.lot'),
          type: 'parking lot',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.pavement.parking'),
          type: 'pavement parking',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.cottage'),
          type: 'cottage',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.duplex'),
          type: 'duplex',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.townhouse'),
          type: 'townhouse',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.villa'),
          type: 'villa',
          isShow: false,
        },
        {
          title: $translate.instant('unit.popup.land.plot'),
          type: 'plot',
          isShow: false,
        },
      ],
      selected = null,
      previous = null;
    $scope.tabs = tabs;
    $scope.selectedIndex = 0;
    $scope.$watch('selectedIndex', function (current, old) {
      previous = selected;
      selected = tabs[current];
    });

    vm.metricsList = [
      {
        id: 'count',
        name: textCount,
        propValues: [
          {
            name: 'tooltip-pattern',
            value: '{value}',
          },
        ],
      },
      {
        id: 'value',
        name: textValue,
        propValues: [
          {
            name: 'tooltip-pattern',
            value: '{value} ' + $rootScope.company.currency,
          },
        ],
      },
      {
        id: 'sqm',
        name: textSqm,
        propValues: [
          {
            name: 'tooltip-pattern',
            value: '{value} ' + $translate.instant('lead.popup.links.sqm'),
          },
        ],
      },
    ];

    var dmTemplates = {
      stock: [
        ['', textNotInStock, textFree, textBooked, textSold],
        ['', '#ef5350', '#4caf50', '#FEC42C', '#bdbdbd'],
      ],
      stockAge: [
        ['', '1-6 ' + textMonths, '6-12 ' + textMonths, '> 12 ' + textMonths],
        ['', '#2196f3', '#DD4D79', '#BD3B47'],
      ],
    };

    getData();

    function getData() {
      if (!requestInProgress) {
        requestInProgress = true;
        DashboardStock.getStock({}).$promise.then(
          function (/** @type {AssortmentResponse} */ response) {
            vm.noData = false;
            requestInProgress = false;
            vm.chartData = response;
            setTabVisibility(Object.keys(response));
            Object.keys(response).map(
              function (/** @type {UnitType} */ unitType) {
                vm.mapForChart(
                  response[unitType],
                  vm.metricStock,
                  'stock',
                  unitType,
                );
                vm.mapForChart(
                  response[unitType],
                  vm.metricStockAge,
                  'stockAge',
                  unitType,
                );
                vm.mapForChart(
                  response[unitType],
                  vm.metricStockRooms,
                  'stockRooms',
                  unitType,
                );
              },
            );
          },
          function (error) {
            vm.noData = true;
            requestInProgress = false;
          },
        );
      }
    }

    /**
     * @param {StockItem[]} stockItems
     * @param {MetricType} metric
     * @param {'stock' | 'stockAge' | 'stockRooms'} type
     * @param {UnitType} unitType
     *
     * @returns {void}
     */
    vm.mapForChart = function (stockItems, metric, type, unitType) {
      var data = [];
      var template = [];
      var calculatedHeight = 0;

      if (type === 'stockRooms' && unitType !== 'apartment') {
        return;
      }

      // we need a separate processing flow for stockRooms because we
      // have dynamic number of room counts per object
      var freeApartmentsChartData = [];

      if (stockItems.length) {
        data = stockItems.map(function (stockItem) {
          /** @type {StockItem['units'][]} */
          var groupUnits = [];
          /** @type {[string, ...number[]]} */
          var result = [stockItem.name];

          switch (type) {
            case 'stock':
              groupUnits = separateIntoGroupsByStatus(stockItem.units);
              break;
            case 'stockAge':
              groupUnits = separateIntoGroupsByDays(stockItem.units);
              break;
            case 'stockRooms':
              freeApartmentsChartData.push(
                separateIntoApartmentsByRooms(stockItem, metric),
              );
              break;
          }

          groupUnits.forEach(function (item) {
            result.push(getMetricValue(item, metric));
          });

          return result;
        });

        calculatedHeight =
          stockItems.length < 4
            ? stockItems.length * (90 + 100 / stockItems.length)
            : stockItems.length * (60 + 100 / stockItems.length);
      }

      if (type === 'stockRooms') {
        vm[type][unitType] = getStockRoomsTemplate(freeApartmentsChartData);
      } else {
        template = dmTemplates[type];
        vm[type][unitType] = template.concat(data);
      }

      $scope.height = calculatedHeight ? calculatedHeight : 545;
      $scope.width = 900;

      $rootScope.$broadcast('chart.update');
    };

    vm.getProperties = function (selectedMetric) {
      vm.metricsList.forEach(function (item) {
        if (item.id == selectedMetric) {
          return item.propValues;
        }
      });
    };

    /**
     * @param {FreeApartmentsChartItem[]} data
     *
     * @return {(string|number)[][]}
     */
    function getStockRoomsTemplate(data) {
      /** @type {number[]} */
      var arrRooms = [];
      /** @type {(string|number)[]} */
      var arrRoomNames = [''];
      /** @type {(string|number)[]} */
      var arrColors = [''];
      var colors = [
        '#5793F3',
        '#DD4444',
        '#FEC42C',
        '#D4DF5A',
        '#66bb6a',
        '#5578C2',
        '#ab47bc',
        '#FD9C35',
        '#3949ab',
        '#e91e63',
        '#00bcd4',
        '#DD4D79',
        '#ffeb3b',
        '#8d6e63',
        '#BD3B47',
      ];
      var colorIndex = 0;

      // collect all possible room counts
      data.forEach(function (item) {
        Object.keys(item.rooms).forEach(function (roomKey) {
          if (arrRooms.includes(Number(roomKey))) {
            return;
          }

          arrRooms.push(Number(roomKey));
        });
      });

      arrRooms.sort(function (a, b) {
        return a - b;
      });

      arrRooms.forEach(function (roomsNumber) {
        arrRoomNames.push(roomsNumber + textRooms);

        arrColors.push(colors[colorIndex % colors.length]);
        colorIndex++;
      });

      return [arrRoomNames, arrColors].concat(
        data.map(function (item) {
          /** @type {(string|number)[]} */
          var row = [item.objName];

          arrRooms.forEach(function (room) {
            row.push(
              typeof item.rooms[room] === 'undefined'
                ? ''
                : Number(item.rooms[room].toFixed(2)),
            );
          });

          return row;
        }),
      );
    }

    /**
     * @param {StockItem} obj
     * @param {MetricType} metric
     *
     * @return {FreeApartmentsChartItem}
     */
    function separateIntoApartmentsByRooms(obj, metric) {
      /** @type {FreeApartmentsChartItem} */
      var groupUnits = {
        objName: obj.name,
        rooms: {},
      };

      obj.units.forEach(function (unit) {
        if (![2, 3].includes(unit.status) || unit.rooms === 0) {
          return;
        }

        var roomKey = String(unit.rooms);

        if (typeof groupUnits.rooms[roomKey] === 'undefined') {
          groupUnits.rooms[roomKey] = 0;
        }

        groupUnits.rooms[roomKey] += getUnitMetric(unit, metric);
      });

      return groupUnits;
    }

    function setTabVisibility(types) {
      types.forEach(function (type) {
        tabs.forEach(function (tab, i) {
          if (tab.type == type) {
            tabs[i].isShow = true;
          }
        });
      });
    }

    /**
     * @param {StockItem['units']} units
     * @param {MetricType} metric
     *
     * @return {number}
     */
    function getMetricValue(units, metric) {
      var result = 0;

      units.forEach(function (item) {
        result += getUnitMetric(item, metric);
      });

      return Number(result.toFixed(2));
    }

    /**
     * @param {StockItem['units'][number]} unit
     * @param {MetricType} metric
     *
     * @return {number}
     */
    function getUnitMetric(unit, metric) {
      var field = '';

      switch (metric) {
        case 'value':
          field = 'total_price';
          break;
        case 'sqm':
          field = 'total_area';
          break;
      }

      switch (metric) {
        case 'sqm':
        case 'value':
          return Number(unit[field]);
        case 'count':
        default:
          return 1;
      }
    }

    /**
     * @param {StockItem['units']} units
     *
     * @return {StockItem['units'][]}
     */
    function separateIntoGroupsByDays(units) {
      /** @type {StockItem['units'][]} */
      var groupUnits = [[], [], []];

      units.forEach(function (unit) {
        if (
          unit.exposition_days != null &&
          (unit.status === 2 || unit.status === 3)
        ) {
          var expositionDays = Number(unit.exposition_days);

          if (expositionDays >= 0 && expositionDays <= 180) {
            groupUnits[0].push(unit);
          } else if (expositionDays >= 181 && expositionDays <= 365) {
            groupUnits[1].push(unit);
          } else if (expositionDays >= 366) {
            groupUnits[2].push(unit);
          }
        }
      });

      return groupUnits;
    }

    /**
     * @param {StockItem['units']} units
     *
     * @return {StockItem['units'][]}
     */
    function separateIntoGroupsByStatus(units) {
      /** @type {StockItem['units'][]} */
      var groupUnits = [[], [], [], []];

      units.forEach(function (unit) {
        groupUnits[Math.min(unit.status, groupUnits.length) - 1].push(unit);
      });

      return groupUnits;
    }
  }
})();
